import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, Input, NgModule } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';

function NgxInstaComponent_ul_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "lib-photo", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const photo_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", photo_r3.link)("thumbnail", photo_r3.images.low_resolution.url);
} }
function NgxInstaComponent_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 4);
    ɵngcc0.ɵɵtemplate(1, NgxInstaComponent_ul_2_li_1_Template, 2, 2, "li", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.photos);
} }
function NgxInstaComponent_ul_3_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "lib-photo", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const photo_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", photo_r5.link)("caption", photo_r5.caption.text)("thumbnail", photo_r5.images.thumbnail.url);
} }
function NgxInstaComponent_ul_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 7);
    ɵngcc0.ɵɵtemplate(1, NgxInstaComponent_ul_3_li_1_Template, 2, 3, "li", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.photos);
} }
class NgxInstaService {
    constructor() { }
}
NgxInstaService.ɵfac = function NgxInstaService_Factory(t) { return new (t || NgxInstaService)(); };
NgxInstaService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxInstaService, factory: NgxInstaService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgxInstaService.ctorParameters = () => [];
/** @nocollapse */ NgxInstaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgxInstaService_Factory() { return new NgxInstaService(); }, token: NgxInstaService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxInstaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InstaAPIService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    getPhotos(config) {
        this.instaURL = 'https://api.instagram.com/' +
            'v1/users/' + config.idUser +
            '/media/recent/' +
            '?count=' + config.count +
            '&access_token=' + config.tokenUser;
        return this.http.get(this.instaURL)
            .pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            /** @type {?} */
            const photos = res;
            return photos.data;
        })))
            .pipe(catchError(this.handleError));
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    handleError(error) {
        /** @type {?} */
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return throwError(errMsg);
    }
}
InstaAPIService.ɵfac = function InstaAPIService_Factory(t) { return new (t || InstaAPIService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
InstaAPIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InstaAPIService, factory: InstaAPIService.ɵfac, providedIn: 'root' });
/** @nocollapse */
InstaAPIService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ InstaAPIService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InstaAPIService_Factory() { return new InstaAPIService(ɵɵinject(HttpClient)); }, token: InstaAPIService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InstaAPIService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxInstaComponent {
    /**
     * @param {?} instaAPI
     */
    constructor(instaAPI) {
        this.instaAPI = instaAPI;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.grid = this.config.grid;
        this.getInstaPhotos();
        console.log(this);
        console.log(this.config);
    }
    /**
     * @return {?}
     */
    getInstaPhotos() {
        this.instaAPI.getPhotos(this.config)
            .subscribe((/**
         * @param {?} photos
         * @return {?}
         */
        photos => this.photos = photos), (/**
         * @param {?} error
         * @return {?}
         */
        error => this.errorMessage = (/** @type {?} */ (error))));
    }
}
NgxInstaComponent.ɵfac = function NgxInstaComponent_Factory(t) { return new (t || NgxInstaComponent)(ɵngcc0.ɵɵdirectiveInject(InstaAPIService)); };
NgxInstaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxInstaComponent, selectors: [["ngx-insta"]], inputs: { config: "config" }, decls: 4, vars: 2, consts: [[1, "section", "section-sm"], [1, "container-fluid", "clearfix", "d-flex"], ["class", "grid", 4, "ngIf"], ["class", "list", 4, "ngIf"], [1, "grid"], [4, "ngFor", "ngForOf"], [3, "link", "thumbnail"], [1, "list"], [3, "link", "caption", "thumbnail"]], template: function NgxInstaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0)(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NgxInstaComponent_ul_2_Template, 2, 1, "ul", 2);
        ɵngcc0.ɵɵtemplate(3, NgxInstaComponent_ul_3_Template, 2, 1, "ul", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.grid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.grid);
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, PhotoComponent]; }, styles: ["@import url(https://fonts.googleapis.com/css?family=Lato:300,400,700|Karma:400,700);ul.grid[_ngcontent-%COMP%]{list-style:none;min-width:60%;width:60%;margin:0 auto;text-align:left;display:-webkit-box;display:flex;flex-wrap:wrap}ul.grid[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:2px;float:left}ul.grid[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:280px;height:280px;display:block;border:none}ul.list[_ngcontent-%COMP%]{list-style:none;width:50%;margin:0 auto;text-align:left;font:300 15px/1.3 Lato;color:#5e5b64}ul.list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:-webkit-box;display:flex;border-bottom:1px solid #ddd;padding:10px;overflow:hidden}ul.list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:120px;height:120px;float:left;border:none}ul.list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-left:135px;font-weight:700;color:#6e7a7f}"] });
/** @nocollapse */
NgxInstaComponent.ctorParameters = () => [
    { type: InstaAPIService }
];
NgxInstaComponent.propDecorators = {
    config: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxInstaComponent, [{
        type: Component,
        args: [{ selector: 'ngx-insta', template: "<section class=\"section section-sm\">\n  <div class=\"container-fluid clearfix d-flex\">\n    <ul class=\"grid\" *ngIf=\"grid\">\n      <!-- A view wtih big Photos and no text -->\n      <li *ngFor=\"let photo of photos\">\n        <lib-photo\n          [link]=\"photo.link\"\n          [thumbnail]=\"photo.images.low_resolution.url\"\n        >\n        </lib-photo>\n      </li>\n    </ul>\n\n    <ul class=\"list\" *ngIf=\"!grid\">\n      <!-- A compact view smaller photos and titles -->\n      <li *ngFor=\"let photo of photos\">\n        <lib-photo\n          [link]=\"photo.link\"\n          [caption]=\"photo.caption.text\"\n          [thumbnail]=\"photo.images.thumbnail.url\"\n        >\n        </lib-photo>\n      </li>\n    </ul>\n  </div>\n</section>\n", styles: ["@import url(https://fonts.googleapis.com/css?family=Lato:300,400,700|Karma:400,700);ul.grid{list-style:none;min-width:60%;width:60%;margin:0 auto;text-align:left;display:-webkit-box;display:flex;flex-wrap:wrap}ul.grid li{padding:2px;float:left}ul.grid li img{width:280px;height:280px;display:block;border:none}ul.list{list-style:none;width:50%;margin:0 auto;text-align:left;font:300 15px/1.3 Lato;color:#5e5b64}ul.list li{display:-webkit-box;display:flex;border-bottom:1px solid #ddd;padding:10px;overflow:hidden}ul.list li img{width:120px;height:120px;float:left;border:none}ul.list li p{margin-left:135px;font-weight:700;color:#6e7a7f}"] }]
    }], function () { return [{ type: InstaAPIService }]; }, { config: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhotoComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
PhotoComponent.ɵfac = function PhotoComponent_Factory(t) { return new (t || PhotoComponent)(); };
PhotoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PhotoComponent, selectors: [["lib-photo"]], inputs: { link: "link", caption: "caption", thumbnail: "thumbnail" }, decls: 3, vars: 2, consts: [[1, "photoContainer"], ["target", "_blank", 3, "href"], [1, "img-fluid", 3, "src"]], template: function PhotoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.link, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.thumbnail, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: ["img[_ngcontent-%COMP%]{display:block;width:324px;height:340px;-o-object-fit:cover;object-fit:cover}"] });
/** @nocollapse */
PhotoComponent.ctorParameters = () => [];
PhotoComponent.propDecorators = {
    link: [{ type: Input }],
    caption: [{ type: Input }],
    thumbnail: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhotoComponent, [{
        type: Component,
        args: [{ selector: 'lib-photo', template: "<div class=\"photoContainer\">\n  <a href={{link}} target=\"_blank\" >\n    <img class=\"img-fluid\" src=\"{{thumbnail}}\" >\n  </a>\n</div>\n", styles: ["img{display:block;width:324px;height:340px;-o-object-fit:cover;object-fit:cover}"] }]
    }], function () { return []; }, { link: [{
            type: Input
        }], caption: [{
            type: Input
        }], thumbnail: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxInstaModule {
}
NgxInstaModule.ɵfac = function NgxInstaModule_Factory(t) { return new (t || NgxInstaModule)(); };
NgxInstaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxInstaModule });
NgxInstaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxInstaModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxInstaComponent, PhotoComponent],
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                exports: [NgxInstaComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxInstaModule, { declarations: function () { return [NgxInstaComponent, PhotoComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule]; }, exports: function () { return [NgxInstaComponent]; } }); })();

export { NgxInstaComponent, NgxInstaModule, NgxInstaService, InstaAPIService as ɵa, PhotoComponent as ɵb };

